import { TerminalItemDto } from "./TerminalInfoDto";

export interface ISuperUserDto {
    contractCode: string | null,
    email: string,
    name: string,
    numberOfTerminals: number,
    numberOfDevs: number,
    numberOfUsers: number,
    surname: string,
    username: string,
    terminalInfo: TerminalItemDto[] | null,
    userType?: string
}

export class SuperUserDto implements ISuperUserDto {
    public contractCode: string | null;
    public email: string;
    public name: string;
    public numberOfTerminals: number;
    public numberOfDevs: number;
    public numberOfUsers: number;
    public surname: string;
    public username: string;
    public terminalInfo: TerminalItemDto[] | null;
    public userType?: string;

    constructor(contractCode: string | null, email: string, name: string, numberOfTerminals: number, numberOfDevs: number, numberOfUsers: number, surname: string, username: string, terminalInfo: TerminalItemDto[], userType: string){
            this.contractCode = contractCode;
            this.email = email;
            this.name = name;
            this.numberOfTerminals = numberOfTerminals;
            this.numberOfDevs = numberOfDevs;
            this.numberOfUsers = numberOfUsers;
            this.surname = surname;
            this.username = username;
            this.terminalInfo = terminalInfo;
            this.userType = userType;
        }
}